<template>
  <div class="instruction-container">
    <!-- 图片列表 -->
    <div class="image-list">
      <div 
        v-for="(image, index) in imageList" 
        :key="index" 
        class="image-wrapper"
      >
        <!-- 骨架屏 -->
        <div v-if="!imageLoaded[index]" class="skeleton">
          <van-skeleton 
            title 
            :row="3" 
            :loading="!imageLoaded[index]"
            class="skeleton-content"
          >
          </van-skeleton>
        </div>
        
        <!-- 图片 -->
        <van-image
          v-show="imageLoaded[index]"
          class="instruction-image"
          width="100%"
          :src="image"
          fit="cover"
          @click="previewImage(index)"
          @load="onImageLoad(index)"
          @error="onImageError(index)"
        />
      </div>
    </div>
    
    <!-- 下载按钮 -->
    <div class="download-section">
      <van-button 
        type="primary" 
        size="large" 
        @click="viewPDF"
        :loading="isDownloading"
      >
        {{ isDownloading ? '下载中...' : '下载使用说明PDF' }}
      </van-button>
    </div>
    
    <!-- 图片预览 -->
    <van-image-preview
      v-model="showPreview"
      :images="imageList"
      :start-position="previewIndex"
      @change="onPreviewChange"
    />
  </div>
</template>

<script>
export default {
  name: 'InstructionPage',
  data() {
    return {
      // 图片链接数组
      imageList: [
        'https://nh5.xtotoro.com/longmao/mfitnessH5/instructions/tiaotiaoleyuan1.jpg',
        'https://nh5.xtotoro.com/longmao/mfitnessH5/instructions/tiaotiaoleyuan2.jpg',
      ],
      // 图片加载状态
      imageLoaded: {},
      // 图片预览相关
      showPreview: false,
      previewIndex: 0,
      // 下载相关
      isDownloading: false,
      // PDF文件地址
      pdfUrl: 'https://nh5.xtotoro.com/longmao/mfitnessH5/instructions/跳跳乐园.pdf'
    }
  },
  
  created() {
    // 初始化图片加载状态
    this.imageList.forEach((_, index) => {
      this.$set(this.imageLoaded, index, false);
    });
  },
  
  methods: {
    // 图片加载完成
    onImageLoad(index) {
      this.$set(this.imageLoaded, index, true);
    },
    
    // 图片加载失败
    onImageError(index) {
      this.$set(this.imageLoaded, index, true);
      this.$toast.fail('图片加载失败');
    },
    
    // 图片预览
    previewImage(index) {
      this.previewIndex = index;
      this.showPreview = true;
    },
    
    // 预览图片切换时的回调
    onPreviewChange(index) {
      this.previewIndex = index;
    },
        // 在线查看PDF
    viewPDF() {
      if (this.isViewLoading) return;
      
      this.isViewLoading = true;
      
      try {
        // 在新窗口/标签页中打开PDF
        window.open(this.pdfUrl, '_blank');
        this.$toast.success('正在打开PDF...');
      } catch (error) {
        console.error('打开PDF失败:', error);
        this.$toast.fail('打开PDF失败，请重试');
      } finally {
        this.isViewLoading = false;
      }
    },
    // 下载PDF
    async downloadPDF() {
      if (this.isDownloading) return;
      
      this.isDownloading = true;
      
      try {
        const link = document.createElement('a');
        link.href = this.pdfUrl;
        link.download = '使用说明.pdf';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        this.$toast.success('开始下载...');
      } catch (error) {
        console.error('下载失败:', error);
        this.$toast.fail('下载失败，请重试');
      } finally {
        this.isDownloading = false;
      }
    }
  }
}
</script>

<style scoped>
.instruction-container {
  /* padding: 16px; */
  background-color: #f5f5f5;
  min-height: 100vh;
}

.title {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
  color: #333;
}

.image-list {
  margin-bottom: 30px;
}

.image-wrapper {
  /* margin-bottom: 15px; */
  position: relative;
}

.image-wrapper:last-child {
  margin-bottom: 0;
}

.instruction-image {
  border-radius: 8px;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
  cursor: pointer;
  display: block;
}

.skeleton {
  height: 200px;
  border-radius: 8px;
  overflow: hidden;
}

.skeleton-content {
  height: 100%;
}

.skeleton-content ::v-deep .van-skeleton__content {
  padding: 0;
}

.skeleton-content ::v-deep .van-skeleton__avatar {
  display: none;
}

.download-section {
  padding: 0 16px;
  margin-top: 20px;
}
</style>